import React, { Component } from 'react'

import { assetUrl } from '../../../config';
import AutoVideo from '../../AutoVideo';
import $ from 'jquery';
import { withT } from '../../../i18n';
class ThereCanOnlyBeOne extends Component {
    server_path = window.src_path;
    constructor() {
        super()
    }

    loadInitJs() {
        /* var item_name = this.pr */
        /* console.log(item_name); */
    }
    componentDidMount() {
        this.loadInitJs();
    }
    render() {
        const { t } = this.props;
        return (
            <>
                <div className="portfolio__main">
                    <div className="wrapper">
                        <div className="portfolio__inner">
                            <div className="left__panel">
                                <div className="image_div">
                                    <AutoVideo controls src={assetUrl('collection/topslide/There-can-only-be-one.mp4')} poster={assetUrl('collection/topslide/There-can-only-be-one.jpg')} aria-label="There Can Only Be One"></AutoVideo>
                                </div>
                            </div>
                            <div className="right__panel">
                                <h2 className="heading">There can only be one</h2>

                                <h2 className="artist_name"><span>{t('work.by')} </span> Gavin Shapiro </h2>
                                <div className="desc">
                                    <p>There can only be one by Gavin Shapiro</p>
                                </div>

                                <a href="https://opensea.io/assets/0xb84e2612b67ddc0a70a71ead9984b4ab820a6565/24800010001" className="css_btn"><span>{t('work.viewArtwork')}</span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default withT(ThereCanOnlyBeOne);
